import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LoanChecklistModel } from '../../core/models/loan-checklist.model';
import { LmsModalFrameComponent } from '../../shared/ui/lms-modal-frame/lms-modal-frame.component';

@Component({
  selector: 'app-loan-checklist-dialog',
  templateUrl: './loan-checklist-dialog.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, LmsModalFrameComponent],
})
export class LoanChecklistDialogComponent {
  checklistItems: {
    key: keyof LoanChecklistModel;
    label: string;
    checked: boolean;
  }[] = [
    {
      key: 'termsAndConditionsExplained',
      label: 'Terms and conditions explained to client.',
      checked: false,
    },
    {
      key: 'barcodedIdUploaded',
      label: "Client's Barcoded ID supplied and uploaded.",
      checked: false,
    },
    {
      key: 'debicheckSlipUploaded',
      label: 'Debicheck slip uploaded on LMS.',
      checked: false,
    },
    {
      key: 'accountNumbersMatch',
      label:
        'The account number on the Debicheck slip corresponds with the account number on the salary advice and bank statement.',
      checked: false,
    },
    {
      key: 'myBenefitsTermsAccepted',
      label: 'I accept the terms and conditions of the MyBenefits product.',
      checked: false,
    },
    {
      key: 'annexureAReceived',
      label:
        'I have received the Annexure A explaining the MyBenefits product.',
      checked: false,
    },
  ];

  reasonForFirstLoan = '';
  reasonForSecondLoan = '';

  get allChecked(): boolean {
    return this.checklistItems.every((item) => item.checked);
  }

  constructor(public modalRef: MdbModalRef<LoanChecklistDialogComponent>) {}

  confirm() {
    const result = new LoanChecklistModel();
    for (const item of this.checklistItems) {
      (result as any)[item.key] = item.checked;
    }
    result.reasonForFirstLoan = this.reasonForFirstLoan;
    result.reasonForSecondLoan = this.reasonForSecondLoan;
    this.modalRef.close(result);
  }

  cancel() {
    this.modalRef.close(null);
  }
}

export interface LoanChecklistItem {
  label: string;
  checked: boolean;
}
